import { useState } from "react";
import { Link, useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { ShoppingCart, ClipboardList, Home, Truck, LayoutGrid } from "lucide-react";
import { useSidebar } from "@/layouts/RootLayout";
import { MobileAppHubSheet } from "@/components/layout/MobileAppHubSheet";

export function DockNavigation() {
    const location = useLocation();
    const { isDockVisible } = useSidebar();
    const [isAppHubOpen, setIsAppHubOpen] = useState(false);

    // Frequently used items for the Dock
    const dockItemsLeft = [
        { title: "Dashboard", icon: Home, href: "/", isActive: location.pathname === "/" },
        { title: "Đơn hàng", icon: ShoppingCart, href: "/orders", isActive: location.pathname.startsWith("/orders") },
    ];

    // Thay nút "+" giữa thanh: tạo mới đã có trong từng trang, nút Ứng dụng đã mở được mọi module
    const dockItemsCenter = [
        { title: "Lệnh SX", icon: ClipboardList, href: "/production-orders", isActive: location.pathname.startsWith("/production-orders") },
    ];

    const dockItemsRight = [
        { title: "Giao hàng", icon: Truck, href: "/delivery", isActive: location.pathname.startsWith("/delivery") },
    ];

    return (
        <div
            data-testid="dock-navigation"
            className={cn(
                "dock-nav fixed bottom-0 left-0 right-0 z-50 md:hidden print:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] transition-transform duration-300 ease-in-out",
                isDockVisible ? "translate-y-0" : "translate-y-full"
            )}
        >
            <div className="flex items-center justify-around py-3 safe-area-bottom px-1">
                {[...dockItemsLeft, ...dockItemsCenter].map((item, idx) => (
                    <Link
                        key={`left-${idx}`}
                        to={item.href}
                        data-testid={`dock-item-${item.href.replace(/[^a-zA-Z0-9]/g, "-")}`}
                        className="flex flex-col items-center justify-center relative w-[20%] gap-1"
                    >
                        <item.icon className={cn(
                            "h-[22px] w-[22px] transition-colors duration-300", 
                            item.isActive ? "text-[#05a660] fill-emerald-50" : "text-slate-500"
                        )} />
                        <span className={cn(
                            "text-[10px] font-medium leading-none", 
                            item.isActive ? "text-[#05a660]" : "text-slate-500"
                        )}>
                            {item.title}
                        </span>
                    </Link>
                ))}

                {dockItemsRight.map((item, idx) => (
                    <Link
                        key={`right-${idx}`}
                        to={item.href}
                        data-testid={`dock-item-${item.href.replace(/[^a-zA-Z0-9]/g, "-")}`}
                        className="flex flex-col items-center justify-center relative w-[20%] gap-1"
                    >
                        <item.icon className={cn(
                            "h-[22px] w-[22px] transition-colors duration-300", 
                            item.isActive ? "text-[#05a660] fill-emerald-50" : "text-slate-500"
                        )} />
                        <span className={cn(
                            "text-[10px] font-medium leading-none", 
                            item.isActive ? "text-[#05a660]" : "text-slate-500"
                        )}>
                            {item.title}
                        </span>
                    </Link>
                ))}

                {/* Nút Ứng Dụng (Mobile App Hub) */}
                <button
                    type="button"
                    data-testid="dock-app-hub-trigger"
                    onClick={() => setIsAppHubOpen(true)}
                    className="flex flex-col items-center justify-center relative w-[20%] gap-1 active:scale-95 transition-transform"
                >
                    <LayoutGrid className={cn(
                        "h-[22px] w-[22px] transition-colors duration-300",
                        isAppHubOpen ? "text-[#05a660]" : "text-slate-500"
                    )} />
                    <span className={cn(
                        "text-[10px] font-medium leading-none",
                        isAppHubOpen ? "text-[#05a660]" : "text-slate-500"
                    )}>
                        Ứng dụng
                    </span>
                </button>
            </div>

            {/* Mobile App Hub Sheet Component */}
            <MobileAppHubSheet open={isAppHubOpen} onOpenChange={setIsAppHubOpen} />
        </div>
    )
}
